module.exports = __webpack_public_path__ + "img/44_56.b0a7d242.png";